<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<ng-select
  [loading]="loader"
  [items]="data"
  bindLabel="user_name"
  groupBy="role_name"
  [groupValue]="groupValue"
  [selectableGroup]="selectableGroup"
  [(ngModel)]="selected"
  (change)="onChange($event)"
  [compareWith]="compare"
  class="user-and-group-select"
  [keyDownFn]="keydown"
  appendTo="body"
>
  <ng-template ng-typetosearch-tmp>
    <div class="ng-option disabled">
      {{ 'START_TYPING' | translate }}
    </div>
  </ng-template>

  <ng-template ng-option-tmp let-item="item" style="z-index: 1056 !important;" let-index="index" let-search="searchTerm" >
    <div class="user-and-group-select-option-wrapper" *ngIf="item.user_name">
      {{ item.user_name }}
    </div>
  </ng-template>

  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
    <div class="ng-option disabled">
      <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
    </div>
  </ng-template>
</ng-select>
